import { AxiosInstance } from "axios";
import axiosBase from "./base";
import {
  ListRootObject,
  RootObject,
} from "view/ProjectDetails/ProjectDetailsModel";
import { PartnersData, PartnersResponse } from "view/Partners/PartnersModel";
import { store } from "store/store";

class AboutService {
  base: AxiosInstance;

  constructor() {
    this.base = axiosBase.base;
  }
  getDocumentsWithAttachment(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(
          `documents?filters[id][$in][0]=2&filters[id][$in][1]=3&populate[attached_document]=id`
        )
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getDocuments(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(`documents?populate=*`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getInstitutions(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(`institutions?populate=*&pagination[pageSize]=9000`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getTeams(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(
          `teams/?populate[cv][populate][attached_document][fields][0]=url&populate[cv][fields][0]=attached_document&populate[photo]=*&pagination[pageSize]=9000`
        )
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }

  getProjects(): Promise<ListRootObject> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(`projects?populate=*`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getActivityReports(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(`activity-reports?populate[documents][populate]=attached_document`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getLegislationOrganisation(ofType = 'primara'): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(
          `legislations?filters[category]=dsu-organization&filters[type]=${ofType}&populate[documents][populate][attached_document]=id`
        )
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getProjectById(id: number): Promise<RootObject> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(
          `projects/${id}?populate=documents,documents.attached_document&populate=cover&populate=gallery`
        )
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  async getPartners(
    typeFilter: string,
    page: number,
    pageSize: number,
    signal?: AbortSignal
  ): Promise<PartnersResponse> {
    const params = new URLSearchParams({ populate: "*" });
    params.set("filters[type][$eq]", typeFilter);
    params.set("pagination[page]", String(page));
    params.set("pagination[pageSize]", String(pageSize));
    params.set("sort", "id:asc");
    const { data } = await this.base.get(`partners?${params}`, { signal });
    return data;
  }

  async getPartnerDirectory(typeFilter: string, signal?: AbortSignal): Promise<PartnersData[]> {
    const partners: PartnersData[] = [];
    let page = 1;
    let pageCount = 1;
    do {
      const response = await this.getPartners(typeFilter, page, 100, signal);
      partners.push(...response.data);
      pageCount = response.meta.pagination.pageCount;
      page += 1;
    } while (page <= pageCount);
    return partners;
  }

  getQualityManagementDocuments(ids: number[]): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (ids.length === 0) {
        return resolve([]);
      }
      const filters = ids
        .map((id, index) => `filters[id][$in][${index}]=${id}`)
        .join("&");
      this.base
        .get(`documents?${filters}&populate=*`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  }

  getAttribution(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      const state = store.getState();
      const language = state.language.language;

      this.base
        .get(`attribution?locale=${language}`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
}
const aboutService = new AboutService();
export default aboutService;
